import api from "@/api";
import SiteCountdownArticleList from "@/views/site/SiteCountdownArticleList.vue";
export default {
  name: "SiteCountdownArticleView",
  components: {
    SiteCountdownArticleList
  },
  data() {
    return {
      tab: '-',
      sites: []
    };
  },
  methods: {
    init() {
      api.getEnumOptionList(4, true).then(ret => {
        this.sites = ret;
        this.tab = ret.length > 0 ? ret[0].label : '-';
      });
    }
  },
  mounted() {
    this.init();
  }
};